export default {
  login: {
    signin: 'Signin',
    signout: 'Signout',
    login: 'Login',
    forgotpassword: 'Forgot your password ?',
    id: 'Login',
    idParticulier:
      'You can authenticate with your: Email address, mobile number or your participant number',
    idCorrespondant: 'Please enter your email address',
    password: 'Password',
    forgotidentifiant: 'Forgot your username ?',
    assistance: 'Support',
    identifiantParticipant: "Member's login",
    tentative: {
      1: 'Incorrect password. You have 2 attempts left',
      2: 'Incorrect password. This is your last attempt, your account will be blocked in the event of an error',
      3: 'Your account has just been locked, please contact CIEM',
    },
    invalid_grant: 'Incorrect user login',
  },
}
